import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { CompanyCategoryDTO } from 'src/app/Common/CompanyCategoryService/CompanyCategory.interface';
import { CompanycategoryService } from 'src/app/Common/CompanyCategoryService/companycategory.service';
import { CompanySubCategoryDTO } from 'src/app/Common/CompanyCategoryService/companysubcategory.interface';
import { combineLatest, firstValueFrom, Subscription } from 'rxjs'; // Import for async Observable handling
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'app-category-select',
  templateUrl: './category-select.component.html',
  styleUrls: ['./category-select.component.css']
})
export class CategorySelectComponent implements OnInit, OnDestroy {
  @Input() form!: FormGroup;
  @Input() categoryControlName: string = '';
  @Input() subCategoryControlName: string = '';
  @Input() placeholder: string = 'Select an option';
  @Output() onBlur : EventEmitter<'category'|'subCategory'> = new EventEmitter<'category'|'subCategory'>()
  categoryControl!:FormControl
  subCategoryControl!:FormControl
  private seedSub?: Subscription;
  constructor(public companyCategoryService: CompanycategoryService) { }

  ngOnInit(): void {
    this.categoryControl = this.form.get(this.categoryControlName) as FormControl;
    this.subCategoryControl = this.form.get(this.subCategoryControlName) as FormControl;

    // A form patched with an already-saved record (edit mode) sets the
    // category control's value directly, bypassing onCategoryChange() below -
    // so SubCategories$ never gets populated for it and the sub-category
    // dropdown shows "No items found" even though a value is bound. Re-derive
    // the subcategory list whenever the category value or the cached category
    // list itself changes, without touching the already-loaded subcategory value.
    this.seedSub = combineLatest([
      this.categoryControl.valueChanges.pipe(startWith(this.categoryControl.value)),
      this.companyCategoryService.Categories$
    ]).subscribe(([categoryName, categories]) => {
      if (!categoryName) return;
      const matched = categories.find(c => c.categoryName === categoryName);
      if (matched) this.companyCategoryService.updateSubCategories(matched.categoryId);
    });
  }

  ngOnDestroy(): void {
    this.seedSub?.unsubscribe();
  }

  // Handle category change
  async onCategoryChange(selectedCategory: CompanyCategoryDTO) {
    if (selectedCategory) {
      this.form.patchValue({
        [this.categoryControlName]: selectedCategory.categoryName, // Set category name
      });

      // Update subcategories for selected category
      this.companyCategoryService.updateSubCategories(selectedCategory.categoryId);

      // Wait for the subcategory list to update
      const updatedSubCategories = await firstValueFrom(this.companyCategoryService.SubCategories$);

      if (selectedCategory.DefaultSubCategory && selectedCategory.DefaultSubCategory > 0) {
        // Find the default subcategory name
        const subCategoryName = updatedSubCategories.find(f => f.subCategoryId === selectedCategory.DefaultSubCategory)?.subCategoryName;

        this.form.patchValue({
          [this.subCategoryControlName]: subCategoryName || null // Set subcategory name or null
        });

        this.onBlur.emit('category')
      } else {
        // Select the first available subcategory
        if (updatedSubCategories.length > 0) {
          this.onSubCategoryChange(updatedSubCategories[0]);
        }
      }
    }
  }

  // Handle subcategory change
  onSubCategoryChange(selectedSubCategory: CompanySubCategoryDTO) {
   
    this.form.patchValue({
      [this.subCategoryControlName]: selectedSubCategory?.subCategoryName || null // Set subcategory name or null
    });

    this.onBlur.emit('subCategory')

  }

 
}
